import { useEffect } from "react";

//redux
import { routes } from "../routes";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";

//utilities/constants
import { pathNames } from "../utilities/constants";

//slice
import { hideOffCanvas, setIsOffCanvasOpen, setIsOffCanvasThreeOpen } from "../commonSlice";

//styles
import "./custom-components.style.scss";

//third party library
import PropTypes from "prop-types";
import _ from "lodash";

const BreadCrumb = ({ path, nonLink }) => {
const dispatch = useDispatch();

// closes drilldown while path updates 

 useEffect(()=>{
              dispatch(
                setIsOffCanvasOpen({
                  isDrilldownOpen: false,
                })                
              );
              dispatch(
                setIsOffCanvasThreeOpen({
                  hideOffCanvasThree: false,
                })                
              );
              dispatch(hideOffCanvas(false));
              
              
    },[path]);
  const navigate = useNavigate();
  let currentPath = "";

  const getPathName = (name, isLastIndex) => {
    if (typeof pathNames[name] !== "undefined") {
      return pathNames[name] && !isLastIndex ? `${pathNames[name]}` : pathNames[name];
    } else {
      const nameArr = decodeURIComponent(name).split(" ");
      const names = _.map(nameArr, item => item.replaceAll("/", " "));
      return names.join(" ");
    }
  };

  const getPathArray = () => {
    const pathArr = path.split("/");
    return _.filter(pathArr, p => p.length > 0);
  };

  const generateUrl = (parentObj, pathArr) => {
    if (_.has(parentObj, "childNavs")) {
      _.forEach(parentObj.childNavs, childNav => {
        generateUrl(childNav, pathArr);
      });
    } else {
      const currentUrl = pathArr.join("/");
      if (currentUrl === parentObj.path) {
        currentPath = currentUrl;
      }
    }
    return currentPath;
  };

  const getUrl = (pathArr, index) => {
    currentPath = "";
    const parentPath = _.find(routes, { path: pathArr[0] });
    const newPathArr = pathArr.slice(0, index + 1);
    const generatedUrl = generateUrl(parentPath, newPathArr);
    return generatedUrl && index < pathArr.length - 1 ? currentPath : "";
  };

  const pathArray = getPathArray();

  return (
    <div>
      {_.map(pathArray, (item, index) => {
        if (item) {
          const isLastIndex = index === pathArray.length - 1;
          const pathName = getPathName(item, isLastIndex);
          const url = getUrl(pathArray, index);
          const matchCount = nonLink?.filter(n => pathArray.includes(n)).length;
          const isNonLink = matchCount === 1;

          return (
            <h3 className="breadCrumb" key={index}>
              {url ? (
                isNonLink ? (
                  <span>{pathName}</span>
                ) : (
                  <a className="breadCrumbItem" onClick={() => navigate(url)}>{pathName}</a>
                )
              ) : (
                <span>{pathName}</span>
              )}
              {index < pathArray.length - 1 && (
                <span>
                  {typeof pathNames[item] === "undefined"
                    ? " - "
                    : pathNames[item].length === 0
                    ? ""
                    : " > "}
                </span>
              )}
            </h3>
          );
        }
        return null;
      })}
    </div>
  );
};

BreadCrumb.propTypes = {
  path: PropTypes.string.isRequired,
  nonLink: PropTypes.arrayOf(PropTypes.string)
};

export default BreadCrumb;
